<main>
  <div class="subs-container center-block">
    <div class="subscribe-container">
      <a class="btn btn-info subscribe-btn" href="https://subscriptions.edina.ac.uk/institutions">Subscribe &raquo;</a>
    </div>

    <h2>New prices for academic year <strong>2026/27</strong>:</h2>

    <p>
      Digimap pricing will continue to use the Jisc banding scheme for 2026/27 to ensure transparency and fairness.
      Following Jisc's re-banding exercise in late 2025 your subscription fees may have been affected by a band change.
      Please check your institution's band if you think this may be the case. The Digimap subscription portal is not yet
      offering subscriptions for 2026-27, pending the completion of some licences. This page will be updated when
      2026/27 subscriptions are available for purchase.
    </p>

    <mat-tab-group>
      <mat-tab>
        <ng-template mat-tab-label>
          <div class="tab-label"><strong>Prices for Higher Education</strong></div>
        </ng-template>

        <table class="table">
          <thead>
            <tr>
              <th scope="col">&nbsp;</th>
              <th colspan="10" scope="colgroup">JISC Band</th>
            </tr>
            <tr>
              <th scope="col">&nbsp;</th>
              <th *ngFor="let band of bands" scope="col" class="band-number">{{ band }}</th>
            </tr>
          </thead>
          <tbody>
            <!-- The bundles -->
            <tr class="group-title highlighted-rows">
              <td colspan="11">Bundle Package Deals</td>
            </tr>
            <tr class="highlighted-rows" *ngFor="let product of getBundles()">
              <td class="product-name">
                <a routerLink="./" fragment="bundle-details">
                  {{ product.name }}
                </a>
              </td>
              <td *ngFor="let price of product.prices" class="price">£{{ price }}</td>
            </tr>

            <!-- The individual products -->
            <tr class="group-title">
              <td colspan="11">Individual Collection Prices</td>
            </tr>
            <tr *ngFor="let product of getProducts()">
              <td [ngSwitch]="product.name" class="product-name" [ngClass]="{ 'is-discount': product.isDiscount }">
                <ng-container *ngSwitchCase="'aerial-lidar-special-case'">
                  <a routerLink="/aerial">Aerial</a> &amp; <a routerLink="/lidar">Lidar</a>
                </ng-container>
                <ng-container *ngSwitchCase="'geology-special-case'">
                  <a routerLink="/geology">Geology</a>
                  (incorporating
                  <a href="/help/our-maps-and-data/geology_overview/#coal-authority-data"
                    >Mining Remediation Authority (formerly The Coal Authority) data</a
                  >)
                </ng-container>
                <a *ngSwitchDefault [href]="product.link">
                  {{ product.name }}
                </a>
                <sup *ngIf="product.daggers">
                  <!-- renders one or more dagger symbols for footnotes -->
                  <ng-container *ngFor="let _ of [].constructor(product.daggers)">✝</ng-container>
                </sup>
              </td>
              <td *ngIf="product.isDiscount" [colSpan]="bands.length" class="discount">
                {{ product.discount }}% discount
              </td>
              <td *ngFor="let price of product.prices" class="price">£{{ price }}</td>
            </tr>
          </tbody>
        </table>

        <p>Prices are exclusive of VAT.</p>
        <p>
          <em
            >* Discount only available when the purchase of both products is made in the
            <strong>same transaction</strong>.
          </em>
          <br />
          <em>✝ Requires a subscription to Digimap OS. </em>
          <br />
          <em>✝✝ Requires a subscription to either 'Aerial &amp; Lidar', the Ultimate bundle or Premium bundle. </em>
        </p>

        <h3 name="bundle-details">Bundle Details</h3>
        <table class="table collection-details">
          <thead>
            <tr>
              <th scope="col">Collection</th>
              <th scope="col">Ultimate</th>
              <th scope="col">Premium</th>
              <th scope="col">Standard</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>OS</strong></td>
              <td class="tick"><span role="img" aria-label="available">&#10003;</span></td>
              <td class="tick"><span role="img" aria-label="available">&#10003;</span></td>
              <td class="tick"><span role="img" aria-label="available">&#10003;</span></td>
            </tr>
            <tr>
              <td><strong>Marine</strong></td>
              <td class="tick"><span role="img" aria-label="available">&#10003;</span></td>
              <td class="tick"><span role="img" aria-label="available">&#10003;</span></td>
              <td class="tick"><span role="img" aria-label="available">&#10003;</span></td>
            </tr>
            <tr>
              <td><strong>Geology</strong></td>
              <td class="tick"><span role="img" aria-label="available">&#10003;</span></td>
              <td class="tick"><span role="img" aria-label="available">&#10003;</span></td>
              <td class="tick"><span role="img" aria-label="available">&#10003;</span></td>
            </tr>
            <tr>
              <td><strong>Historic</strong></td>
              <td class="tick"><span role="img" aria-label="available">&#10003;</span></td>
              <td class="tick"><span role="img" aria-label="available">&#10003;</span></td>
              <td class="tick"><span role="img" aria-label="available">&#10003;</span></td>
            </tr>
            <tr>
              <td><strong>Environment</strong></td>
              <td class="tick"><span role="img" aria-label="available">&#10003;</span></td>
              <td class="tick"><span role="img" aria-label="available">&#10003;</span></td>
              <td class="tick"><span role="img" aria-label="available">&#10003;</span></td>
            </tr>
            <tr>
              <td><strong>Aerial</strong></td>
              <td class="tick"><span role="img" aria-label="available">&#10003;</span></td>
              <td class="tick"><span role="img" aria-label="available">&#10003;</span></td>
              <td class="cross"><span role="img" aria-label="not available">&#10008;</span></td>
            </tr>
            <tr>
              <td><strong>Lidar</strong></td>
              <td class="tick"><span role="img" aria-label="available">&#10003;</span></td>
              <td class="tick"><span role="img" aria-label="available">&#10003;</span></td>
              <td class="cross"><span role="img" aria-label="not available">&#10008;</span></td>
            </tr>
            <tr>
              <td><strong>Global</strong></td>
              <td class="tick"><span role="img" aria-label="available">&#10003;</span></td>
              <td class="cross"><span role="img" aria-label="not available">&#10008;</span></td>
              <td class="cross"><span role="img" aria-label="not available">&#10008;</span></td>
            </tr>
            <tr>
              <td><strong>Society</strong></td>
              <td class="tick"><span role="img" aria-label="available">&#10003;</span></td>
              <td class="cross"><span role="img" aria-label="not available">&#10008;</span></td>
              <td class="cross"><span role="img" aria-label="not available">&#10008;</span></td>
            </tr>
            <tr>
              <td><strong>Verisk</strong></td>
              <td class="tick"><span role="img" aria-label="available">&#10003;</span></td>
              <td class="cross"><span role="img" aria-label="not available">&#10008;</span></td>
              <td class="cross"><span role="img" aria-label="not available">&#10008;</span></td>
            </tr>
            <tr>
              <td><strong>agCensus</strong></td>
              <td class="tick"><span role="img" aria-label="available">&#10003;</span></td>
              <td class="cross"><span role="img" aria-label="not available">&#10008;</span></td>
              <td class="cross"><span role="img" aria-label="not available">&#10008;</span></td>
            </tr>
            <tr>
              <td><strong>OS National Geographic Database (NGD)</strong></td>
              <td class="tick"><span role="img" aria-label="available">Upgrade available</span></td>
              <td class="tick"><span role="img" aria-label="available">Upgrade available</span></td>
              <td class="tick"><span role="img" aria-label="available">Upgrade available</span></td>
            </tr>
            <tr>
              <td><strong>National Tree Map</strong></td>
              <td class="tick"><span role="img" aria-label="available">Upgrade available</span></td>
              <td class="tick"><span role="img" aria-label="available">Upgrade available</span></td>
              <td class="tick"><span role="img" aria-label="available">Upgrade available</span></td>
            </tr>
            <tr>
              <td><strong>Aerial Extra</strong></td>
              <td class="tick"><span role="img" aria-label="available">Upgrade available</span></td>
              <td class="tick"><span role="img" aria-label="available">Upgrade available</span></td>
              <td class="cross"><span role="img" aria-label="not available">&#10008;</span></td>
            </tr>
            <tr>
              <td><strong>LandClan</strong></td>
              <td class="tick"><span role="img" aria-label="available">Upgrade available</span></td>
              <td class="tick"><span role="img" aria-label="available">Upgrade available</span></td>
              <td class="tick"><span role="img" aria-label="available">Upgrade available</span></td>
            </tr>
          </tbody>
        </table>
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          <div class="tab-label"><strong>Prices for Further Education</strong></div>
        </ng-template>
        <table class="table">
          <thead>
            <tr>
              <th scope="col">JISC Band</th>
              <th scope="col">
                <a routerLink="./" fragment="bundle-details"> Ultimate Bundle </a>
              </th>
              <th scope="col">
                <a routerLink="./" fragment="bundle-details"> Premium Bundle </a>
              </th>
              <th scope="col">
                <a routerLink="./" fragment="bundle-details"> Standard Bundle </a>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>C, D, E</td>
              <td>£524</td>
              <td>£414</td>
              <td>£308</td>
            </tr>
            <tr>
              <td>F, G, H</td>
              <td>£472</td>
              <td>£378</td>
              <td>£276</td>
            </tr>
            <tr>
              <td>I, J</td>
              <td>£391</td>
              <td>£312</td>
              <td>£246</td>
            </tr>
          </tbody>
        </table>

        <p>Prices are exclusive of VAT.</p>

        <table class="table collection-details" name="bundle-details">
          <thead>
            <tr>
              <th scope="col">Collection</th>
              <th scope="col">Ultimate</th>
              <th scope="col">Premium</th>
              <th scope="col">Standard</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>OS</strong></td>
              <td class="tick"><span role="img" aria-label="available">&#10003;</span></td>
              <td class="tick"><span role="img" aria-label="available">&#10003;</span></td>
              <td class="tick"><span role="img" aria-label="available">&#10003;</span></td>
            </tr>
            <tr>
              <td><strong>Marine</strong></td>
              <td class="tick"><span role="img" aria-label="available">&#10003;</span></td>
              <td class="tick"><span role="img" aria-label="available">&#10003;</span></td>
              <td class="tick"><span role="img" aria-label="available">&#10003;</span></td>
            </tr>
            <tr>
              <td><strong>Geology</strong></td>
              <td class="tick"><span role="img" aria-label="available">&#10003;</span></td>
              <td class="tick"><span role="img" aria-label="available">&#10003;</span></td>
              <td class="tick"><span role="img" aria-label="available">&#10003;</span></td>
            </tr>
            <tr>
              <td><strong>Historic</strong></td>
              <td class="tick"><span role="img" aria-label="available">&#10003;</span></td>
              <td class="tick"><span role="img" aria-label="available">&#10003;</span></td>
              <td class="tick"><span role="img" aria-label="available">&#10003;</span></td>
            </tr>
            <tr>
              <td><strong>Environment</strong></td>
              <td class="tick"><span role="img" aria-label="available">&#10003;</span></td>
              <td class="tick"><span role="img" aria-label="available">&#10003;</span></td>
              <td class="tick"><span role="img" aria-label="available">&#10003;</span></td>
            </tr>
            <tr>
              <td><strong>Aerial</strong></td>
              <td class="tick"><span role="img" aria-label="available">&#10003;</span></td>
              <td class="tick"><span role="img" aria-label="available">&#10003;</span></td>
              <td class="cross"><span role="img" aria-label="not available">&#10008;</span></td>
            </tr>
            <tr>
              <td><strong>Lidar</strong></td>
              <td class="tick"><span role="img" aria-label="available">&#10003;</span></td>
              <td class="tick"><span role="img" aria-label="available">&#10003;</span></td>
              <td class="cross"><span role="img" aria-label="not available">&#10008;</span></td>
            </tr>
            <tr>
              <td><strong>Global</strong></td>
              <td class="tick"><span role="img" aria-label="available">&#10003;</span></td>
              <td class="cross"><span role="img" aria-label="not available">&#10008;</span></td>
              <td class="cross"><span role="img" aria-label="not available">&#10008;</span></td>
            </tr>
            <tr>
              <td><strong>Society</strong></td>
              <td class="tick"><span role="img" aria-label="available">&#10003;</span></td>
              <td class="cross"><span role="img" aria-label="not available">&#10008;</span></td>
              <td class="cross"><span role="img" aria-label="not available">&#10008;</span></td>
            </tr>
            <tr>
              <td><strong>Verisk</strong></td>
              <td class="tick"><span role="img" aria-label="available">&#10003;</span></td>
              <td class="cross"><span role="img" aria-label="not available">&#10008;</span></td>
              <td class="cross"><span role="img" aria-label="not available">&#10008;</span></td>
            </tr>
            <tr>
              <td><strong>agCensus</strong></td>
              <td class="tick"><span role="img" aria-label="available">&#10003;</span></td>
              <td class="cross"><span role="img" aria-label="not available">&#10008;</span></td>
              <td class="cross"><span role="img" aria-label="not available">&#10008;</span></td>
            </tr>
          </tbody>
        </table>
      </mat-tab>
    </mat-tab-group>
  </div>
</main>
